const addAnimationClass = (node, className) => {
  if (node) {
    return new Promise((resolve, reject) => {
      node.classList.add('animation-on', className);
      function handleAnimationEnd(event) {
        event.stopPropagation();
        node.classList.remove('animation-on', className);
        resolve('Animation ended');
      }
      node.addEventListener('animationend', handleAnimationEnd, { once: true });
    });
  }
};

let totalNumberOfQuestions = 0,
  numberOfQuestionShown = 5,
  answerInputCollection = '',
  hiddenQuestionCollection = '';

const quiz = {
  init: function (questions) {
    totalNumberOfQuestions = questions.length;
    const quizWrap = document.querySelector('.quiz-wrap');
    const quizHtml = `<ol class="questions ps-4"></ol>
                      <div class="quiz-nav my-4 py-3 d-flex w-100 justify-content-center align-items-center">
                        <span class="quiz-tally d-inline-block mx-1"></span>
                        <button class="show-more-btn btn btn-outline-primary next-btn mx-1" type="button">Show More</button>
                      </div>`;
    quizWrap.insertAdjacentHTML('beforeend', quizHtml);
    const questionsWrap = document.querySelector('ol.questions');
    const questionsArray = questions.map((questionItem, qIndex) => {
      const answers = Object.entries(questionItem.answers).map((item, index) => {
        const correct = item[0] === questionItem.correctAnswer ? 'y' : 'n';
        return `<label class="quiz-answer d-block mb-2">
                  <input name="q${qIndex}" value="${correct}" type="radio" />
                  <span>${item[1]}</span>
                </label>`;
      });
      const shown = qIndex < numberOfQuestionShown ? 'shown' : 'hidden';
      return `<li class="question-wrap ${shown} mb-4">
                <h3 class="question mb-2">${questionItem.question}</h3>
                ${answers.join('')}
                <div class="correct-description alert alert-success d-none mt-3">
                  <p class="mb-0 text-dark"><strong>Correct:</strong> ${questionItem.description}</p>
                </div>
              </li>`;
    });
    questionsWrap.insertAdjacentHTML('beforeend', questionsArray.join(''));
    document.querySelector('.quiz-nav .quiz-tally').innerHTML = `${numberOfQuestionShown} of ${totalNumberOfQuestions}`;
    document.querySelector('.quiz-wrap .show-more-btn').addEventListener('click', function () {
      quiz.showMore();
    });
    answerInputCollection = document.querySelectorAll(".question-wrap input[type='radio']");
    quiz.eventsInit();
  },
  checkAnswer: function (e) {
    const answer = e.target;
    const answerWrap = answer.closest('.quiz-answer');
    const answerCollection = answer.closest('.question-wrap').querySelectorAll('.quiz-answer');
    const correctDescription = answer.closest('.question-wrap').querySelector('.correct-description');
    if (answer.value === 'y') {
      answerWrap.classList.add('correct-answer');
      correctDescription.classList.remove('d-none');
      correctDescription.classList.add('d-block');
    } else {
      addAnimationClass(answerWrap, 'shakeX');
      for (let answer of answerCollection) {
        answer.classList.remove('correct-answer');
      }
      correctDescription.classList.remove('d-block');
      correctDescription.classList.add('d-none');
    }
  },
  eventsInit: function () {
    // need to grab the updated list of questions/answers in case new questions was added to the DOM
    answerInputCollection = document.querySelectorAll(".question-wrap input[type='radio']");
    for (let answer of answerInputCollection) {
      answer.addEventListener('click', quiz.checkAnswer, true);
    }
  },
  showMore: function () {
    // cleaning up event listener for optimization
    for (let answer of answerInputCollection) {
      answer.removeEventListener('click', quiz.checkAnswer, true);
    }
    hiddenQuestionCollection = document.querySelectorAll('.question-wrap.hidden');
    for (let i = 0; i < 5; i++) {
      hiddenQuestionCollection[i].classList.remove('hidden');
      hiddenQuestionCollection[i].classList.add('shown');
      numberOfQuestionShown++;
      if (numberOfQuestionShown === totalNumberOfQuestions) {
        break;
      }
    }
    if (numberOfQuestionShown >= totalNumberOfQuestions) {
      document.querySelector('.quiz-wrap .quiz-nav .show-more-btn').classList.add('d-none');
    }
    document.querySelector(
      '.quiz-wrap .quiz-nav .quiz-tally'
    ).innerHTML = `${numberOfQuestionShown} of ${totalNumberOfQuestions}`;
    quiz.eventsInit();
  },
};
